import os from "os";
import { toast } from "react-toastify";

const AWS = require('aws-sdk')
AWS.config.update({accessKeyId: 'AKIAJ4NDCUVOBECPLGBA', secretAccessKey: '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', region: "ap-south-1"})

const s3 = new AWS.S3()

let apiProtocol = "https://";
let sslProtocol = "https://";

//Use during SSL
const productionAPIHost = 'api.healthsetgo.com'
const productionURLs = ['healthsetgo.com', productionAPIHost]
const productionAPIPort = ''

// const stagingAPIHost = '35.154.246.223'
const stagingAPIHost = "api.healthsetgo.info";
const stagingURLs = ["localhost", stagingAPIHost];
const stagingAPIPort = "";

const appBaseURLProduction = 'https://myhealth.healthsetgo.com/'
const appBaseURLStaging = 'http://35.154.246.223:8052/'

//----------- PRODUCTION SECTION ----------------//
//const apiHost = productionAPIHost
//const devPort = ''
//const apiPort = productionAPIPort
//const apiUrl = sslProtocol + apiHost
//const s3URL = "http://hsgbucket.s3.amazonaws.com"

//----------- STAGING SECTION ----------------//
const apiHost = productionAPIHost;
const devPort = "";
const apiPort = productionAPIPort;
const apiUrl = apiProtocol + apiHost;
const s3URL = "https://hsgbucket.s3.amazonaws.com";

const s3BucketName = 'hsgbucket'
const s3BucketKey = 'web-resources/public/school/'
const s3signedUrlExpireSeconds = 60 * 60

const qcCheckedStatusMap = {
    CHECKED: 45,
    PUBLISHED: 46,
};

const activeStatusMap = {
    ACTIVE: 1,
    DRAFT: 2,
    DELETE: 3,
    REJECTED: 4,
};

const orgTypeMap = {
    SCHOOL: 1,
    MSP: 2,
    ISP: 3,
};

const allTabsMap = {
    SCHOOL: "school",
    QC: "qc",
    QC_DETAIL: "qc-detail",
    TC: "tc",
    MANAGER: "manager",
};


const allowedUserRole = [5, 18, 20, 23, 22, 3];
//---------- CONSTANTS USED FOR CLIENT -----------//

const roles = {
    1: {
        value: "HSG OPS",
        orgActive: {
            [orgTypeMap.SCHOOL]: `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`,
            [orgTypeMap.MSP]: `{${activeStatusMap.ACTIVE}}`,
            [orgTypeMap.ISP]: `{${activeStatusMap.ACTIVE}}`,
        },
    },
    2: { value: "HSG Finance" },
    //3: { value: 'HSG Community Manager' },
    4: { value: "School Admin" },
    5: {
        value: "Parent",
        orgActive: {
            [orgTypeMap.SCHOOL]: `{${activeStatusMap.ACTIVE}}`,
        },
    },
    6: { value: "Finance team" },
    7: { value: "In-house doctor/CHM" },
    3: {
        value: "CHM",
        detail: "Community Health Manager",
        orgActive: {
            [orgTypeMap.SCHOOL]: `{${activeStatusMap.ACTIVE}}`,
            [orgTypeMap.MSP]: `{${activeStatusMap.ACTIVE}}`,
            [orgTypeMap.ISP]: `{${activeStatusMap.ACTIVE}}`,
        },
    },
    8: {
        value: "CHM Manager",
        orgActive: {
            [orgTypeMap.SCHOOL]: `{${activeStatusMap.ACTIVE}}`,
        },
    },
    9: { value: "Student" },
    //10: { value: 'Guest' },
    14: {
        value: "HSG SA ISP",
        orgActive: {
            [orgTypeMap.ISP]: `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`,
        },
    },
    15: {
        value: "HSG SA MSP",
        orgActive: {
            [orgTypeMap.MSP]: `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`,
        },
    },
    17: {
        value: "HSG Ops Manager",
        orgActive: {
            [orgTypeMap.SCHOOL]: `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`,
            [orgTypeMap.MSP]: `{${activeStatusMap.ACTIVE}}`,
            [orgTypeMap.ISP]: `{${activeStatusMap.ACTIVE}}`,
        },
    },
};

/* 
1 | OPS
2 | Finance
3 | CHM
4 | School Admin
5 | Parent
6 | Finance team
7 | In-house doctor/CHM
8 | CHM Manager
9 | Student
10 | Doctor
11 | Onsite Coordinator
12 | HSG Super Admin
13 | Guest
14 | SA-ISP
15 | SA-MSP
16 | CEO(Super Admin)
17 | OPS Manager


const roles = {
  'OPS_MANAGER' : {value: 'HSG Ops Manager'},
  2 : {value: 'HSG Finance'},
  3 : {value: 'HSG Community Manager'},
  4 : {value: 'School Admin'},
  5 : {value: 'Parent'},
  6 : {value: 'Finance team'},
  7 : {value: 'In-house doctor/CHM'},
  'CHM' : {value: 'CHM', detail: 'Community Health Manager'},
  9 : {value: 'Student'},
 10 : {value: 'Guest'},
} */

const getIdFromUrl = (url, pos) => {
    let id;
    url = url.split("/");
    return (id = parseInt(url[url.length - pos]));
};

const roleIdMap = {
    OPS_MANAGER: 17,
    PARENT: 5,
    CHM: 3,
    CHM_MANAGER: 8,
    STUDENT: 9,
    TEACHER: 18,
    NURSE: 19,
    NON_TEACHING: 20,
    DEFAULT_SIGNUP: 22,
    COLLEGE_STUDENT: 23
};

/**
 * Please find the roles and its id's below
 */

/* 1 | OPS
2 | Finance
3 | CHM
4 | School Admin
5 | Parent
6 | Finance team
7 | In - house doctor / CHM
8 | CHM Manager
9 | Student
10 | Doctor
11 | Onsite Coordinator
12 | HSG Super Admin
13 | Guest
14 | SA - ISP
15 | SA - MSP
16 | CEO(Super Admin)
17 | OPS Manager */

const roleIdMapV2 = {
    OPS_MANAGER: { value: 17, detail: "HSG Ops Manager", orgActive: "{1,2}" },
    CHM: { value: 3, detail: "Community Health Manager", orgActive: "{1}" },
    CHM_MANAGER: { value: 8, detail: "CHM Manager", orgActive: "{1}" },
};

// 31 | Created
// 32 | Scheduled
// 33 | In Progress
// 34 | Complete
// 35 | Cancelled

const eventTrackStatus = {
    CREATED: 31,
    SCHEDULED: 32,
    IN_PROGRESS: 33,
    COMPLETE: 34,
    CANCELLED: 35,
};

const eventTrackRankMap = {
    START_NODE: 1,
    ONBOARD_SCHOOL: 2,
    CAREBOX: 3,
    VISION_CAREBOX: 3,
    BALANCED_CAREBOX: 3,
    SUGAR_CAREBOX: 3,
    BLOOD_DONATION_CAREBOX: 3,
    IMMUNIZATION_CAREBOX: 3,
    HEART_CAREBOX: 3,
    HYGIENE_CAREBOX: 3,
    STUDENT_LIST: 4,
    SCHEDULE_HEATH_CHECKUP: 5,
    DOWNLOAD_OMR: 6,
    HEALTH_CHECKUP: 7,
    UPLOAD_HEATH_CHECKUP_DATA: 8,
    QC: 9,
    TC: 10,
    END_NODE: 11,
};

const getNode = (events, filterVal) => {
    let startNode = [];
    if (events && events.length > 0) {
        startNode = events.filter((e, i) => {
            if (Boolean(e.event_custom_json)) {
                return e.event_custom_json.name === filterVal;
            }
        });
        return startNode.length > 0 ? startNode[0] : undefined;
    } else return [];
};

// nodeId of the Student Assessment Data Node to be excluded from View/Edit
const qcMetricsInertNodeId = 1;

// Report names for fetching Pentaho reports
const pentahoReports = {
    ENT: "ent",
    DENTAL: "dental",
    EYE: "eye",
    GROWTH: "growth",
    PHYSICAL: "physical",
};

// Report name mapping for the report status api
const reportStatus = {
    ENT: "Ent Checkup",
    DENTAL: "Dental Checkup",
    EYE: "Eye Checkup",
    GROWTH: "Height and Growth",
    PHYSICAL: "Physical Checkup",
};

// Offer Types
const offerTypes = {
    MEDICAL: 0,
    WELLNESS: 1,
    NUTRITION: 2,
};

function showToaster(message, type, duration) {

    toast(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: duration || 4000,
        hideProgressBar: true,
        toastClassName: "hsg-toast",
        type: toast.TYPE[type],
    });
}

const titleCase = (str) => {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    // Directly return the joined string
    return splitStr.join(' '); 
 }

// Growth Report Constants

const bmiRange = [
    { key: "Under Weight", color: "#FFA200" },
    { key: "Normal", color: "#55BC6E" },
    { key: "Over Weight", color: "#FFA200" },
    { key: "Obese", color: "#FFA200" },
];

const heightRange = [
    { key: "Short Stature", color: "#FFA200" },
    { key: "Normal Stature", color: "#55BC6E" },
    { key: "Tall Stature", color: "#FFA200" },
];

const weightRange = [
    { key: "Skinny", color: "#FFA200" },
    { key: "Normal", color: "#55BC6E" },
    { key: "Tall fat", color: "#FFA200" },
];

function renderDayOptions() {
    const result = [];

    for (let i = 1; i < 32; i++) {
        result.push(i < 10 ? `0${i}` : i.toString());
    }

    return result;
}

function renderYearOptions() {
    const result = [];

    let year = 2019;
    for (let i = 0; i < 68; i++) {
        result.push(year.toString());
        year--;
    }

    return result;
}

const genderMap = {
    GENDER: null,
    MALE: "M",
    FEMALE: "F",
    OTHER: "O",
};

const genderList = ["GENDER", "MALE", "FEMALE", "OTHER"];

const DOBDay = renderDayOptions();
const DOBMonth = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
const DOBYear = renderYearOptions();

function compileUsersDOB(day, month, year) {
    let dob;
    month = DOBMonth.findIndex((e) => e === month) + 1;

    if (day && month && year) {
        dob = `${year}-${month < 10 ? `0${month}` : month}-${day}`;
    }

    return dob;
}

let callParams = {
    company: "healthsetgo1",
    sid: "9e7f3f287a533dab6e6539e1d43cd6fe1814a446",
    From: "9818888781",
    CallerId: "09243422233",
    CallType: "trans",
    protocol: "https://",
};

const navigationBarMidPoint = 1199;
const navigationBarFlipPoint = 767;

const covidDeclarationFormIdMap = {
    [roleIdMap.STUDENT]: 1,
    [roleIdMap.COLLEGE_STUDENT]: 7,
    [roleIdMap.TEACHER]: 3,
    [roleIdMap.NURSE]: 4,
    [roleIdMap.NON_TEACHING]: 5,
}

const covidDeclarationDefaultOrganization = 319

function getCovidGlobalDashboardReplaceText (name) {

    let replaceArray = [
        {key: '&', value: 'and'}
    ]
    
    replaceArray.forEach(element => {
        name = name.replace(element.key, element.value)
    });
  
    return name
  }

   
const stateCodeMap = {
    'andaman and nicobar islands':'an',
    'andhra pradesh':'ap',
    // 'andhra pradesh (new)':'ad',
    'arunachal pradesh':'ar',
    'assam':'as',
    'bihar':'br',
    'chandigarh':'ch',
    'chattisgarh':'ct',
    'dadra and nagar haveli':'dn',
    'daman and diu':'dd',
    'delhi':'dl',
    'goa':'ga',
    'gujarat':'gj',
    'haryana':'hr',
    'himachal pradesh':'hp',
    'jammu and kashmir':'jk',
    'jharkhand':'jh',
    'karnataka':'ka',
    'kerala':'kl',
    // 'lakshadweep islands':'ld',
    'madhya pradesh':'mp',
    'maharashtra':'mh',
    'manipur':'mn',
    'meghalaya':'me',
    'mizoram':'mi',
    'nagaland':'nl',
    'odisha':'or',
    'pondicherry':'py',
    'punjab':'pb',
    'rajasthan':'rj',
    'sikkim':'sk',
    'tamil nadu':'tn',
    'telangana':'ts',
    'tripura':'tr',
    'uttar pradesh':'up',
    'uttarakhand':'ut',
    'west bengal':'wb'
  }

  function convertObjectToArray(obj) {
    var key,
        keys = Object.keys(obj);
    var n = keys.length;
  
    var newArray = []
    while (n--) {
      var newObj = {};
        key = keys[n];
        newObj[key.toLowerCase()] = obj[key];
  
        newArray.push(newObj)
    }
  
    return newArray
  }

  const communicationMap = {
    'HELPERS': {
      'EMAIL_RECIPIENTS': (recipients)=>{
        return recipients.map(e => ({
          name: e.name,
          email: e.email,
          type: e.type || 'to'
        }))
      },
      'EMAIL_VARIABLES': (variables)=>{
        let keys = Object.keys(variables)
  
        return keys.map(k => ({
          'name': k,
          'content': variables[k]
        }))
      },
      'CALL_API_END': (params)=> {
        return {
          apiEndPoint: params.protocol + params.company + ':' + params.sid + '@api.exotel.com/v1/Accounts/' + params.company
        }
      }
    },
    'EMAILS': {
      'FIRST_COVID_SUBMISSION': {
        [roleIdMap.TEACHER]: {
          'template': 'teacher-and-non-teaching-first-covid-submission'
        },
        [roleIdMap.NON_TEACHING]: {
          'template': 'teacher-and-non-teaching-first-covid-submission'
        },
        [roleIdMap.PARENT]: {
            'template': 'parent-and-student-first-covid-submission'
        },
        [roleIdMap.STUDENT]: {
            'template': 'parent-and-student-first-covid-submission'
        },
        [roleIdMap.DEFAULT_SIGNUP]: {
          'template': 'independent-member-first-covid-submission'
        }
      },
      'INVITATION_REQUEST': {
          'template': 'hsg-user-invitation-link-request'
      },
      'MAGIC_LINK_REQUEST': {
        'template': 'member-login-using-magic-link'
      },
      'MEMBER_SIGNUP_WELCOME': {
        'template': 'member-signup-welcome-email'
      },
      'SUPPORT_MESSAGE': {
        'template': 'user-support-new-platform',
        'recipients': [{
          name: 'HealthSetGo',
          email: 'support@healthsetgo.com'
        }],
        'platform': 'My Community'
      }
    },
    'CALL': {
        'DEFAULT_PARAMS': {
            company: 'healthsetgo1',
            sid: '9e7f3f287a533dab6e6539e1d43cd6fe1814a446',
            To: '01141182986',
            From: '09555553311',
            CallerId: '01140845133',
            CallType: 'trans',
            protocol: 'https://',
            apiEndPoint: `https://healthsetgo1:9e7f3f287a533dab6e6539e1d43cd6fe1814a446@api.exotel.com/v1/Accounts/healthsetgo1`
        }
      }
  }
  
  function formatProfilePicURL(profilePic) {

    if (!profilePic) {
        return null
    }

    let possiblePic, possibleStage

    possiblePic = profilePic && profilePic.split ? profilePic.split("/") : []
    possibleStage = profilePic && profilePic.split ? profilePic.split("blob") : []

    let base = possiblePic[possiblePic.length - 2]
    let name = possiblePic[possiblePic.length - 1]

    base = base === "user-profile-pictures" ? "user-profile-pictures" : ""

    return name ? getS3ImageSignedURL(base ? `${base}/${name}` : name) : null
}

  function getS3ImageSignedURL(name) {
      //   if (params.Authorization && params.Signature) {
      //       const credentials = params.Credential.split("/")
      //       const signature = hmacSHA512(
      //           hmacSHA512(hmacSHA512(hmacSHA512("AWS4" + credentials[0], credentials[1]), credentials[2]), credentials[3]),
      //           credentials[4]
      //       )
      //       return `${url}?AWSAccessKeyId=${credentials[0]}&Expires=1599092954&Signature=${params.Signature}`
      //     //   return `${url}?X-Amz-Algorithm=${params.Authorization}&X-Amz-Credential=${params.Credential}&X-Amz-Date=${params["Signed-Headers"]}&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=${params.Signature}`
      //   }

      let picName = name && typeof name === 'string' ? decodeURI(name) : name
      picName = picName && typeof picName === 'string' ? picName.replace(/\+/g, ' ') : picName

      const params = { Bucket: s3BucketName, Key: 'web-resources/public/school/' + picName, Expires: s3signedUrlExpireSeconds }
      const url = s3.getSignedUrl("getObject", params)
      return url
  }

export default {

    stagingAPIHost,
    productionAPIHost,
  
    appBaseURLProduction,
    appBaseURLStaging,

    formatProfilePicURL,
    getS3ImageSignedURL,
    communicationMap,

    getCovidGlobalDashboardReplaceText,
    stateCodeMap,
    convertObjectToArray,

    covidDeclarationDefaultOrganization,
    covidDeclarationFormIdMap,

    navigationBarMidPoint,
    navigationBarFlipPoint,
  
    callParams,

    genderList,
    DOBDay,
    DOBMonth,
    DOBYear,

    compileUsersDOB,

    genderMap,
    getNode,
    getIdFromUrl,
    roles,
    roleIdMap,
    roleIdMapV2,
    apiUrl,
    apiHost,
    apiProtocol,
    sslProtocol,
    devPort,
    apiPort,
    s3URL,
    activeStatusMap,
    orgTypeMap,
    eventTrackStatus,
    qcCheckedStatusMap,
    qcMetricsInertNodeId,
    eventTrackRankMap,
    allTabsMap,
    pentahoReports,
    reportStatus,
    offerTypes,
    showToaster,

    bmiRange,
    heightRange,
    weightRange,
    titleCase,
    allowedUserRole
};
